import BrowserRouter from '@main/core/BrowserRouter';
import WdLayout from '@main/core/WdLayout';
import WdTheme from '@main/core/WdTheme';
import { useDispatch, useSelector } from 'react-redux';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { selectCurrentLanguageDirection } from 'app/store/i18nSlice';
import themeLayouts from 'src/app/layout/themeLayouts';
import { selectMainTheme } from 'app/store/core/settingsSlice';
import NotificationClientProvider from '@modules/notifications/providers/NotificationClientProvider';
import { getNotifications } from '@modules/notifications/store';
import WdMessage from '@main/core/WdMessage';
import { findNotifications } from 'src/app/api/profile';
import BootstrapProvider from 'src/app/bootstrap/BootstrapProvider';
import RoutesScope from 'src/app/routing/RoutesScope';
import { showMessage } from 'app/store/core/messageSlice';
import withAppProviders from './withAppProviders';

const emotionCacheOptions = {
  rtl: {
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
  ltr: {
    key: 'muiltr',
    stylisPlugins: [],
    insertionPoint: document.getElementById('emotion-insertion-point'),
  },
};

function App() {
  const Dispatch = useDispatch();

  const { config } = useSelector((state) => state.config);
  const { api } = config;
  const { notify, records } = config.sockets;

  const profile = useSelector((state) => state.profile);
  const { token } = useSelector((state) => state.auth);
  const langDirection = useSelector(selectCurrentLanguageDirection);
  const mainTheme = useSelector(selectMainTheme);

  // ---------- Modulo de notificaciones
  const handleUpdateNotificationList = () => {
    Dispatch(getNotifications({ _request: findNotifications }));
  };

  // ---------- Mensajes del Router
  const handleRouterMessage = (message) => {
    Dispatch(showMessage({ message }));
  };

  return (
    <CacheProvider value={createCache(emotionCacheOptions[langDirection])}>
      <WdTheme theme={mainTheme} direction={langDirection}>
        <BrowserRouter>
          <BootstrapProvider
            setServices={['profileInfo']}
            buildNavbarWithRouterFilters
            // filterRouterByModules
            filterRouterByScopes
          >
            <RoutesScope userScopes={profile.scopes}>
              <NotificationClientProvider
                // enabled={token !== null && notify.host !== undefined}
                user={profile}
                baseUri={notify.host}
                space={notify.namespace}
                originPlatform="manager"
                onTrigger={handleUpdateNotificationList}
              >
                <WdLayout layouts={themeLayouts} />
              </NotificationClientProvider>
            </RoutesScope>
            <WdMessage />
          </BootstrapProvider>
        </BrowserRouter>
      </WdTheme>
    </CacheProvider>
  );
}

export default withAppProviders(App)();
